@import '@hevoio/hevo-ui-toolkit/styles/variables';

.jsonEditor {
  height: 300px;
  border: solid $border-width $divider-color;
  border-radius: $border-radius-md;
  background: $surface-bg;
}

.jsonEditorCodeEditorWithoutLineNumber {
  padding: $spacer * 0.5 0;
}
